
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/logistics/products/last-mile-delivery-routing-algorithms",
      function () {
        return require("private-next-pages/industries/logistics/products/last-mile-delivery-routing-algorithms.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/logistics/products/last-mile-delivery-routing-algorithms"])
      });
    }
  